export default {"src":"/_next/static/media/0x46e7628e8b4350b2716ab470ee0ba1fa9e76c6c5.fa0c5f23.svg","height":47,"width":47,"blurWidth":0,"blurHeight":0};